<template>
	<div>
		<el-dialog :close-on-click-modal="false" :visible.sync="isShowHint" center title="提示" top="25vh" width="40%">
			<span style="font-weight: bold; font-size: 1.1em">{{ productData.msgHint }}</span>
			<div style="margin-top: 10px"></div>
			<template slot="footer">
				<div class="u-flex-col u-col-center">
					<el-button
						v-for="(itemData, index) in productData.productList"
						:key="index"
						style="margin: 5px"
						type="primary"
						@click="onChoiceType(index)">
						{{ itemData.memo }}
					</el-button>
				</div>
			</template>
		</el-dialog>

		<el-dialog
			:close-on-click-modal="false"
			:visible.sync="isShowInsureHint"
			center
			title="提示"
			top="25vh"
			width="40%">
			<div v-if="isXsmJianzhu(currentChoiceData.insureType)" class="insure-hint">
				广东企业灵活用工保的方案，请注意第4项拒保的职业都不保的，请留意本方案：
				1、身故与残疾的情况下出险必须要有安全带及高空等特种作业证，没有其一的话会有25%的免赔；
				2、出险请务必72小时内报案，超时报案免赔50%没有通融的
				3、方案不减员，1个月、3个月保单不能替换，出过险的人员不能替换。 4、伤残使用的是新残标《人体损伤致伤残鉴定标准》
				5、仅门诊治疗没有误工费，出险须到二级及以上公立医院就诊才能赔，医疗社保范围内100%赔付；
				6、1-3类职业不保高空，4-6类职业可保高空。
			</div>
			<div v-else class="insure-hint">
				广东制造行业雇主险的方案，请注意本方案除制造行业的职业都不保的，请留意本方案：
				1、身故与残疾的情况下出险必须要有安全带及高空等特种作业证，没有其一的话会有25%的免赔；
				2、出险请务必72小时内报案，超时报案免赔50%没有通融的； 3、方案只能年保，本方案中途申请退保或批减，可退保费为0；
				4、伤残使用工标十级5%起；
				5、仅门诊治疗没有误工费，出险须到二级及以上公立医院就诊才能赔，医疗社保范围内100%赔付；
				6、1-3类职业不保高空，4-6类职业可保高空； 7、扩展24小时意外医疗，非工作时间死亡伤残赔付不超过投保额的50%；
				8、猝死赔付责任为投保限额的20%； 9、只保工作场所在广东的广东企业。
			</div>
			<template slot="footer">
				<div class="u-flex-row u-row-center">
					<el-button plain style="margin: 0 10px" type="primary" @click="isShowInsureHint = false">
						谢谢，投/被保险人不同意此告知
					</el-button>
					<el-button style="margin: 0 10px" type="primary" @click="onChoiceType(3)">投/被保险人均已知悉</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

export default {
	name: 'xsmYinLiuDialog',
	mixins: [],
	components: {},
	props: {},
	data() {
		return {
			isShowHint: false,
			productData: {},
			interData: {},
			isShowInsureBegin: false,
			currentChoiceData: {},
			isShowInsureHint: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		showXsmInsuresHint(productData) {
			this.productData = productData
			this.isShowHint = true
		},
		// 0 1， 3再次确认
		onChoiceType(type = 0) {
			if (type === 3) {
				this.isShowInsureHint = false
				setTimeout(() => {
					//需要弹投保提示窗
					this.$emit('onShowInsureHint', this.currentChoiceData)
				}, 100)
			} else {
				this.isShowHint = false
				this.currentChoiceData = this.productData.productList[type]
				setTimeout(() => {
					this.isShowInsureHint = true
				}, 250)
			}
		},
		isXsmJianzhu(insureType) {
			return insureType == 16
		},
	},
	created() {},
	mounted() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
	padding: 15px 30px;
}

::v-deep .el-checkbox__label {
	margin-top: 4px;
}

.insure-hint {
	white-space: pre-line;
	font-weight: bold;
}
</style>
